module.exports = __webpack_public_path__ + "static/media/facebook.94e5d65f.svg";